<template>
  <div :class="$style.spacious">
    <spacer :y="5" />
    <div :class="$style.outer_flex">
      <div :class="$style.outer_flex_left">
        <contents-box type="inner">
          <div :class="$style.filter">
            <!-- 期間 -->
            <dl>
              <dt><i class="fa-solid fa-calendar-days"></i>期間</dt>
              <dd>
                <div :class="$style.datePicker">
                  <date-small-picker
                    :name="'startDate'"
                    v-model="startDate"
                    v-on:sendDate="receiveDate" />
                </div>
                <div :class="$style.tilde">~</div>
                <div :class="$style.datePicker">
                  <date-small-picker
                    :name="'endDate'"
                    v-model="endDate"
                    v-on:sendDate="receiveDate" />
                </div>
              </dd>
            </dl>
            <spacer :y="2" />

            <!-- 組織タイプと利用者タイプと学校タイプ -->
            <div :class="$style.filter_row">
              <div v-if="!isTeacherMode" :class="$style.filter_item_auto">
                <div :class="$style.filter_label"><i class="fa-solid fa-building"></i> 組織タイプ</div>
                <ul :class="$style.select">
                  <li v-for="item in organizationTypeItems" :key="item">
                    <input
                      type="checkbox"
                      :id="item.name"
                      :value="item.value"
                      :checked="item.checked"
                      v-on:change="updateType($event, 'organization')">
                    <label :for="item.name">{{ item.label }}</label>
                  </li>
                </ul>
              </div>
              <div :class="$style.filter_item_auto">
                <div :class="$style.filter_label"><i class="fa-solid fa-users"></i> 利用者タイプ</div>
                <ul :class="$style.select">
                  <li v-for="item in filteredAccountTypeItems" :key="item">
                    <input
                      type="checkbox"
                      :id="item.name"
                      :value="item.value"
                      :checked="item.checked"
                      v-on:change="updateType($event, 'account')">
                    <label :for="item.name">{{ item.label }}</label>
                  </li>
                </ul>
              </div>
              <div v-if="!isTeacherMode && isOrganizationTypeSchoolValid" :class="$style.filter_item_auto">
                <div :class="$style.filter_label"><i class="fa-solid fa-school"></i> 学校タイプ</div>
                <ul :class="$style.select">
                  <li v-for="item in schoolTypeItems" :key="item">
                    <input
                      type="checkbox"
                      :id="item.name"
                      :value="item.value"
                      :checked="item.checked"
                      v-on:change="updateType($event, 'school')">
                    <label :for="item.name">{{ item.label }}</label>
                  </li>
                </ul>
              </div>
            </div>
            <spacer :y="2" />

            <!-- 学校・企業ソートと8地方区分 -->
            <div v-if="!isTeacherMode" :class="$style.filter_row">
              <dl :class="$style.filter_item_auto">
                <dt><i class="fa-solid fa-arrow-down-wide-short"></i>{{ schoolSortLabel }}</dt>
                <dd>
                  <select
                    :class="[$style.select_box, $style.select_box_school]"
                    name="school"
                    id="school"
                    v-on:change="updateSchool">
                    <option :value="0" :selected="targetSchool === 0">すべて</option>
                    <option
                      v-for="n of filteredSchools"
                      :key="n"
                      :value="n.id"
                      :selected="n.id === targetSchool">{{ n.name }}</option>
                  </select>
                </dd>
              </dl>
              <dl :class="$style.filter_item_auto">
                <dt><i class="fa-solid fa-arrow-down-wide-short"></i>8地方区分</dt>
                <dd>
                  <select
                    :class="$style.select_box"
                    name="area"
                    id="area"
                    v-model="targetArea">
                    <option :value="0" :selected="targetArea === 0">全国</option>
                    <option
                      v-for="i of areas"
                      :key="i"
                      :value="i"
                      :selected="i === targetArea">{{ i }}</option>
                  </select>
                </dd>
              </dl>
            </div>
            <spacer :y="2" />

            <!-- 除外 -->
            <div :class="$style.filter_label"><i class="fa-regular fa-filter"></i> 除外</div>
            <div>
              <input
                type="checkbox"
                id="exclusionCancel"
                v-model="exclusionCancel">
              <label for="exclusionCancel">事前キャンセルを除外</label>
            </div>
            <spacer :y="3" />

            <!-- 実行ボタン -->
            <div>
              <loader-simple :flag="flag.loader" :mini="true">
                <basic-btn
                  tag="button"
                  addClass="wide"
                  :disabled="flag.loader || startDate === null || endDate === null "
                  @click="startAnalytics()">実行する</basic-btn>
                  <p v-if="startDate === null || endDate === null">期間を選択してください</p>
              </loader-simple>
            </div>
          </div>
        </contents-box>
      </div>
      <spacer :x="1" />
      <div :class="$style.outer_flex_right">
        <div :class="$style.analytics_common">
          <analytics-common
            :starting="startDate"
            :textData="analyzedTextData"
            :onlineData="analyzedReserveData"
            :backendData="backendData"
            :allFilter="allFilter"
            :schools="schools"
            :accountsData="accountsData"
            :tabName="tabQueryName"
            :analyticsApiPrefix="analyticsApiPrefix"
            :authHeaders="teacherAuthHeaders"
            :mode="mode"
            :loading="analyticsLoading"
            @send-data="getAccounts"
            @send-trend="getAnalytics"
            ref="analyticsCommon" />
        </div>
        <spacer :y="5" />
        <!-- タブによってグラフ内容出しわけ（表示のみ管理） -->
        <div
          :class="$style.search_tab">
          <ul :class="$style.tab_list">
            <li
              v-for="tab in analytics_tabs"
              :key="tab"
              :class="[`${tab.check ? $style.check_tab : $style.not_check}`, $style[`tab_${tab.value}`]]">
              <div @click="toggleTab(tab.value)" :class="$style.cursor_poiter">{{ tab.label }}</div>
            </li>
          </ul>
        </div>
        <loader-simple :flag="!backendData">
          <contents-box>
            <div v-if="backendData">
              <div v-for="tab in analytics_tabs" :key="tab">
                <div v-if="tab.check">
                  <div>
                    <!-- テキスト -->
                    <div v-if="tab.value === 'text'">
                      <!-- <div v-if="!analyzedTextData.allCount">
                        <p>選択の期間内に該当するデータがありません</p>
                      </div> -->
                      <div>
                        <div :class="$style.wide_contents">
                          <contents-box type="inner">
                            <div v-if="backendData" :class="$style.graph_contents">
                              <div :class="$style.graph_contents_title">総利用状況</div>
                              <spacer :y="2" />
                              <mix-graph
                                :labels-data="backendData.month.graph.text.labels"
                                :datasets-data="filterMonthGraphDatasets(backendData.month.graph.text.datasets)" />
                            </div>
                          </contents-box>
                        </div>
                        <div :class="$style.card_container">
                          <div :class="$style.card"> <!-- 画面幅に応じて個数の変化するグラフボックス -->
                            <contents-box
                              type="inner"
                              style="height: 100%;"> <!-- あまり綺麗ではないがここで高さ調整 -->
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">性別</div>
                                <spacer :y="2" />
                                <div :class="$style.graph_contents_figure">
                                  <div :class="$style.graph_size_max">
                                    <pie-graph
                                      :labelsData="backendData.gender.text.labels"
                                      :datasetsData="backendData.gender.text.datasets" />
                                  </div>
                                </div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>性別</th><th>件数</th><th>ユニーク数</th></tr>
                                    <tr v-for="(label, i) in backendData.gender.text.labels" :key="`gender-text-${label}`">
                                      <td :class="$style.alg_center"><span :style="`color: ${backendData.gender.text.datasets.backgroundColor[i]}`">● </span>{{ label }}　</td>
                                      <td :class="$style.alg_right">{{ backendData.gender.text.datasets.data[i] || 0 }}件</td>
                                      <td :class="$style.alg_right">{{ (backendData.gender.text.unique[genderUniqueKeys[i]] || []).length }}人</td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.alg_center">合計　</td>
                                      <td :class="$style.alg_right">{{ backendData.gender.text.datasets.data.reduce((a, b) => a + (b || 0), 0) }}件</td>
                                      <td :class="$style.alg_right">{{ genderUniqueKeys.reduce((sum, k) => sum + ((backendData.gender.text.unique[k] || []).length), 0) }}人</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">新規・継続</div>
                                <spacer :y="2" />
                                <div :class="$style.graph_contents_figure">
                                  <div :class="$style.graph_size_max">
                                    <pie-graph
                                      :labelsData="backendData.newAndContinued.text.labels"
                                      :datasetsData="backendData.newAndContinued.text.datasets" />
                                  </div>
                                </div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>種別</th><th>ユニーク数</th></tr>
                                    <tr v-for="data, index in backendData.newAndContinued.text.labels" :key="data">
                                      <td :class="$style.alg_center">
                                        <span :style="`color: ${backendData.newAndContinued.text.datasets.backgroundColor[index]}`">●</span>{{ data }}
                                      </td>
                                      <td :class="$style.alg_right">{{ backendData.newAndContinued.text.datasets.data[index] }}人</td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.alg_center">合計</td>
                                      <td :class="$style.alg_right">{{ calcSum(backendData.newAndContinued.text.datasets.data) }}人</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div
                            v-if="backendData && calcSum(backendData.schoolYear.text.datasets.data) > 0"
                            :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">学年
                                  <GuideIcon
                                    icon="fa-regular fa-circle-question"
                                    boxSize="230"
                                    hoverText="テキスト相談受付時の学年" />
                                </div>
                                <spacer :y="2" />
                                <div :class="$style.graph_contents_figure">
                                  <div :class="$style.graph_size_max">
                                    <pie-graph
                                      :labelsData="backendData.schoolYear.text.labels"
                                      :datasetsData="backendData.schoolYear.text.datasets" />
                                  </div>
                                </div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>学年</th><th>件数</th></tr>
                                    <tr v-for="data, index in backendData.schoolYear.text.labels" :key="data">
                                      <td :class="$style.alg_center">
                                        <span :style="`color: ${backendData.schoolYear.text.datasets.backgroundColor[index]}`">●</span>{{ data }}
                                      </td>
                                      <td :class="$style.alg_right">{{ backendData.schoolYear.text.datasets.data[index] }}件</td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.alg_center">合計</td>
                                      <td :class="$style.alg_right">{{ calcSum(backendData.schoolYear.text.datasets.data) }}件</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">平均利用回数</div>
                                <spacer :y="2" />
                                <div :class="$style.graph_contents_figure">
                                  <div :class="$style.graph_size_max">
                                    <div :class="$style.usage_circle" :style="{ background: getTabColor('text'), visibility: isValidAve(usedTextAve) ? 'visible' : 'hidden' }">
                                      <div :class="$style.usage_circle_inner">
                                        <div :class="$style.usage_circle_value">{{ usedTextAve }}</div>
                                        <div :class="$style.usage_circle_unit">件/人</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>最大利用者</th><th>件数</th></tr>
                                    <template v-if="backendData.maxUsageUser && backendData.maxUsageUser.text && backendData.maxUsageUser.text.length > 0">
                                      <tr v-for="user in backendData.maxUsageUser.text" :key="user.userId">
                                        <td :class="$style.alg_center">
                                          <router-link
                                            :to="`${historyBasePath}/${user.userId}`"
                                            target="_blank"
                                            :class="$style.user_link">
                                            {{ user.customerId }}
                                          </router-link>
                                        </td>
                                        <td :class="$style.alg_right">{{ user.count }}件</td>
                                      </tr>
                                    </template>
                                    <tr v-else>
                                      <td :class="$style.alg_center" colspan="2">データなし</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">年齢</div>
                                <spacer :y="2" />
                                <div :class="$style.graph_contents_figure">
                                  <div :class="$style.graph_size_max">
                                    <pie-graph
                                      :labelsData="backendData.ageData.text.labels"
                                      :datasetsData="backendData.ageData.text.datasets"
                                      labelSuffix="歳" />
                                  </div>
                                </div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>年齢</th><th>件数</th></tr>
                                    <tr v-for="data, index in backendData.ageData.text.labels" :key="data">
                                      <td :class="$style.alg_center">
                                        <span :style="`color: ${backendData.ageData.text.datasets.backgroundColor[index]}`">●</span>{{ data }}歳
                                      </td>
                                      <td :class="$style.alg_right">{{ backendData.ageData.text.datasets.data[index] }}件</td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.alg_center">合計</td>
                                      <td :class="$style.alg_right">{{ calcSum(backendData.ageData.text.datasets.data) }}件</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">時間</div>
                                <spacer :y="2" />
                                <div :class="$style.graph_contents_figure">
                                  <div :class="$style.graph_size_max">
                                    <pie-graph
                                      :labelsData="backendData.scheduleTime.text.labels"
                                      :datasetsData="backendData.scheduleTime.text.datasets" />
                                  </div>
                                </div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>時間帯</th><th>件数</th></tr>
                                    <tr v-for="data, index in backendData.scheduleTime.text.labelsForTable" :key="data">
                                      <td :class="$style.alg_center">
                                        <span :style="`color:${backendData.scheduleTime.text.datasets.backgroundColor[index]}`">●</span>{{ data }}
                                      </td>
                                      <td :class="$style.alg_right">{{ backendData.scheduleTime.text.datasets.data[index] }}件</td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.alg_center">合計</td>
                                      <td :class="$style.alg_right">{{ calcSum(backendData.scheduleTime.text.datasets.data) }}件</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                        </div>
                        <spacer :y="2" />
                        <p :class="$style.graph_contents_title">ココモニチェック</p>
                        <div :class="$style.card_container">
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">全体</div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>相談件数</th><td :class="$style.alg_right">{{ ctValue('texts') }}件</td></tr>
                                    <tr><th>利用者数</th><td :class="$style.alg_right">{{ backendData.month.table.userCount.text }}人</td></tr>
                                    <tr><th>ココモニチェック</th><td :class="$style.alg_right">{{ calcWeightAve(backendData.month.counts.text, backendData.month.weight.text) ?? '- ' }}点</td></tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">月</div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>年-月</th><th>平均点</th></tr>
                                    <tr v-for="data, index in backendData.month.graph.text.labels" :key="data">
                                      <th>{{ data }}</th>
                                      <td :class="$style.alg_right">{{ backendData.month.graph.text.datasets[0].data[index] }}点</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">曜日</div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>曜日</th><th>平均点</th></tr>
                                    <tr v-for="data in backendData.month.table.weekDays.text"
                                      :key="data"
                                      v-show="data.value > 0">
                                      <th>{{ data.label }}</th>
                                      <td :class="$style.alg_right">{{ data.value }}点</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">性別</div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr>
                                      <th>性別</th><th>平均点</th>
                                    </tr>
                                    <tr v-for="data in backendData.month.table.gender.text" :key="data">
                                      <th>{{ data.label }}</th>
                                      <td :class="$style.alg_right">{{ data.value ?? '- ' }}点</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">時間</div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>受付時間帯</th><th>平均点</th></tr>
                                    <tr v-for="data, index in backendData.scheduleTime.text.labelsForTable"
                                      :key="data">
                                      <th :class="$style.alg_center">
                                        {{ data }}
                                      </th>
                                      <td :class="$style.alg_right">
                                        {{ backendData.month.table.receptionTime.text[index] }}点
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                        </div>
                        <spacer :y="2" />
                        <div :class="$style.wide_contents">
                          <contents-box
                            type="inner">
                            <div v-if="backendData" :class="$style.graph_contents">
                              <div :class="$style.graph_contents_title">相談内容</div>
                              <spacer :y="2" />
                              <div :class="$style.wide_contents_block">
                                <div :class="$style.graph_contents_figure_full">
                                  <div :class="$style.graph_size_max">
                                    <bar-graph
                                      Axis="y"
                                      :labelsData="backendData.worries.text.labels"
                                      :datasetsData="backendData.worries.text.datasets"
                                      :showDataLabels="true"
                                      colorMode="text" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </contents-box>
                        </div>
                      </div>
                    </div>

                    <!-- オンライン -->
                    <div v-if="['online', 'onlineOnly', 'virtualOnly'].includes(tab.value) && backendData?.month?.graph?.[tab.value]?.datasets?.[0]?.data?.length">
                      <div>
                        <div :class="$style.wide_contents">
                          <contents-box type="inner">
                            <div v-if="backendData" :class="$style.graph_contents">
                              <div :class="$style.graph_contents_title">総利用状況</div>
                              <spacer :y="2" />
                              <mix-graph
                                :labels-data="backendData.month.graph[tab.value].labels"
                                :datasets-data="filterMonthGraphDatasets(backendData.month.graph[tab.value].datasets)" />
                            </div>
                          </contents-box>
                        </div>
                        <div :class="$style.card_container">
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">性別</div>
                                <spacer :y="2" />
                                <div :class="$style.graph_contents_figure">
                                  <div :class="$style.graph_size_max">
                                    <pie-graph
                                      :labelsData="backendData.gender[tab.value].labels"
                                      :datasetsData="backendData.gender[tab.value].datasets" />
                                  </div>
                                </div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>性別</th><th>人数</th><th>ユニーク数</th></tr>
                                    <tr v-for="(label, i) in backendData.gender[tab.value].labels" :key="`gender-${tab.value}-${label}`">
                                      <td :class="$style.alg_center"><span :style="`color: ${backendData.gender[tab.value].datasets.backgroundColor[i]}`">● </span>{{ label }}　</td>
                                      <td :class="$style.alg_right">{{ backendData.gender[tab.value].datasets.data[i] || 0 }}件</td>
                                      <td :class="$style.alg_right">{{ (backendData.gender[tab.value].unique[genderUniqueKeys[i]] || []).length }}人</td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.alg_center">合計　</td>
                                      <td :class="$style.alg_right">{{ backendData.gender[tab.value].datasets.data.reduce((a, b) => a + (b || 0), 0) }}件</td>
                                      <td :class="$style.alg_right">{{ genderUniqueKeys.reduce((sum, k) => sum + ((backendData.gender[tab.value].unique[k] || []).length), 0) }}人</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">新規・継続</div>
                                <spacer :y="2" />
                                <div :class="$style.graph_contents_figure">
                                  <div :class="$style.graph_size_max">
                                    <pie-graph
                                      :labelsData="backendData.newAndContinued[tab.value].labels"
                                      :datasetsData="backendData.newAndContinued[tab.value].datasets" />
                                  </div>
                                </div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>種別</th><th>ユニーク数</th></tr>
                                    <tr v-for="data, index in backendData.newAndContinued[tab.value].labels" :key="data">
                                      <td :class="$style.alg_center">
                                        <span :style="`color: ${backendData.newAndContinued[tab.value].datasets.backgroundColor[index]}`">●</span>{{ data }}
                                      </td>
                                      <td :class="$style.alg_right">{{ backendData.newAndContinued[tab.value].datasets.data[index] }}人</td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.alg_center">合計</td>
                                      <td :class="$style.alg_right">{{ calcSum(backendData.newAndContinued[tab.value].datasets.data) }}人</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div
                            v-if="backendData && calcSum(backendData.schoolYear[tab.value].datasets.data) > 0"
                            :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">学年
                                  <GuideIcon
                                    icon="fa-regular fa-circle-question"
                                    boxSize="230"
                                    hoverText="予約申し込み時の学年" />
                                </div>
                                <spacer :y="2" />
                                <div :class="$style.graph_contents_figure">
                                  <div :class="$style.graph_size_max">
                                    <pie-graph
                                      :labelsData="backendData.schoolYear[tab.value].labels"
                                      :datasetsData="backendData.schoolYear[tab.value].datasets" />
                                  </div>
                                </div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>学年</th><th>件数</th></tr>
                                    <tr v-for="data, index in backendData.schoolYear[tab.value].labels" :key="data">
                                      <td :class="$style.alg_center">
                                        <span :style="`color:${backendData.schoolYear[tab.value].datasets.backgroundColor[index]}`">●</span>{{ data }}
                                      </td>
                                      <td :class="$style.alg_right">{{ backendData.schoolYear[tab.value].datasets.data[index] }}件</td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.alg_center">合計</td>
                                      <td :class="$style.alg_right">{{ calcSum(backendData.schoolYear[tab.value].datasets.data) }}件</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">平均利用回数</div>
                                <spacer :y="2" />
                                <div :class="$style.graph_contents_figure">
                                  <div :class="$style.graph_size_max">
                                    <div :class="$style.usage_circle" :style="{ background: getTabColor(tab.value), visibility: isValidAve(getAveValue(tab.value)) ? 'visible' : 'hidden' }">
                                      <div :class="$style.usage_circle_inner">
                                        <div :class="$style.usage_circle_value">{{ tab.value === 'onlineOnly' ? usedOnlineOnlyAve : usedVirtualOnlyAve }}</div>
                                        <div :class="$style.usage_circle_unit">件/人</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>最大利用者</th><th>件数</th></tr>
                                    <template v-if="backendData.maxUsageUser && backendData.maxUsageUser[tab.value] && backendData.maxUsageUser[tab.value].length > 0">
                                      <tr v-for="user in backendData.maxUsageUser[tab.value]" :key="user.userId">
                                        <td :class="$style.alg_center">
                                          <router-link
                                            :to="`${historyBasePath}/${user.userId}`"
                                            target="_blank"
                                            :class="$style.user_link">
                                            {{ user.customerId }}
                                          </router-link>
                                        </td>
                                        <td :class="$style.alg_right">{{ user.count }}件</td>
                                      </tr>
                                    </template>
                                    <tr v-else>
                                      <td :class="$style.alg_center" colspan="2">データなし</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">年齢</div>
                                <spacer :y="2" />
                                <div :class="$style.graph_contents_figure">
                                  <div :class="$style.graph_size_max">
                                    <pie-graph
                                      :labelsData="backendData.ageData[tab.value].labels"
                                      :datasetsData="backendData.ageData[tab.value].datasets"
                                      labelSuffix="歳" />
                                  </div>
                                </div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>年齢</th><th>人数</th></tr>
                                    <tr v-for="data, index in backendData.ageData[tab.value].labels" :key="data">
                                      <td :class="$style.alg_center">
                                        <span :style="`color:${backendData.ageData[tab.value].datasets.backgroundColor[index]}`">●</span>{{ data }}歳
                                      </td>
                                      <td :class="$style.alg_right">{{ backendData.ageData[tab.value].datasets.data[index] }}件</td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.alg_center">合計</td>
                                      <td :class="$style.alg_right">{{ calcSum(backendData.ageData[tab.value].datasets.data) }}件</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">時間</div>
                                <spacer :y="2" />
                                <div :class="$style.graph_contents_figure">
                                  <div :class="$style.graph_size_max">
                                    <pie-graph
                                      :labelsData="backendData.scheduleTime[tab.value].labels"
                                      :datasetsData="backendData.scheduleTime[tab.value].datasets" />
                                  </div>
                                </div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>時間帯</th><th>件数</th></tr>
                                    <tr v-for="data, index in backendData.scheduleTime[tab.value].labelsForTable" :key="data">
                                      <td :class="$style.alg_center">
                                        <span :style="`color:${backendData.scheduleTime[tab.value].datasets.backgroundColor[index]}`">●</span>{{ data }}
                                      </td>
                                      <td :class="$style.alg_right">{{ backendData.scheduleTime[tab.value].datasets.data[index] }}件</td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.alg_center">合計　</td>
                                      <td :class="$style.alg_right">{{ calcSum(backendData.scheduleTime[tab.value].datasets.data) }}件</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">専門家</div>
                                <spacer :y="2" />
                                <div :class="$style.graph_contents_figure">
                                  <div :class="$style.graph_size_max">
                                    <donut-graph
                                      :labelsData="backendData.experts[tab.value].labels"
                                      :datasetsData="backendData.experts[tab.value].datasets"/>
                                  </div>
                                </div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr>
                                      <th>専門家</th><th>件数</th>
                                    </tr>
                                    <tr
                                      v-for="expert, index in backendData.experts[tab.value].labels"
                                      :key="expert">
                                      <td :class="$style.alg_center">
                                        <span :style="`color: ${backendData.experts[tab.value].datasets.backgroundColor[index]}`">●</span>
                                        {{ expert }}
                                      </td>
                                      <td :class="$style.alg_right">{{ backendData.experts[tab.value].datasets.data[index] }}件</td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.alg_center">合計</td>
                                      <td :class="$style.alg_right">{{ calcSum(backendData.experts[tab.value].datasets.data) }}件</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">指導区分</div>
                                <spacer :y="2" />
                                <div :class="$style.graph_contents_figure">
                                  <div :class="$style.graph_size_max">
                                    <donut-graph
                                      :labelsData="backendData.guidance[tab.value].labels"
                                      :datasetsData="backendData.guidance[tab.value].datasets"/>
                                  </div>
                                </div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr>
                                      <th>区分</th><th>件数*</th>
                                    </tr>
                                    <tr
                                      v-for="type, index in backendData.guidance[tab.value].labels"
                                      :key="type">
                                      <td :class="$style.alg_center">
                                        <span :style="`color: ${backendData.guidance[tab.value].datasets.backgroundColor[index]}`">●</span>
                                        {{ type }}
                                      </td>
                                      <td :class="$style.alg_right">{{ backendData.guidance[tab.value].datasets.data[index] }}件</td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.alg_center">合計</td>
                                      <td :class="$style.alg_right">{{ calcSum(backendData.guidance[tab.value].datasets.data) }}件</td>
                                    </tr>
                                  </table>
                                </div>
                                <p :class="$style.note_text">*アクセス日によって異なる場合があります</p>
                              </div>
                            </contents-box>
                          </div>
                        </div>
                        <spacer :y="3" />
                        <p :class="$style.graph_contents_title">ココモニチェック</p>
                        <div :class="$style.card_container">
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">全体</div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th rowspan="3">予約件数</th><th>合計</th><td :class="$style.alg_right">{{ ctValue(tab.value) }}件</td></tr>
                                    <tr><th>医師</th><td :class="$style.alg_right">{{ backendData.experts[tab.value].datasets.data[0] }}件</td></tr>
                                    <tr><th>心理士</th><td :class="$style.alg_right">{{ backendData.experts[tab.value].datasets.data[1] }}件</td></tr>
                                    <tr><th rowspan="3">実施件数</th><th>合計</th><td :class="$style.alg_right">{{ ctValue(tab.value + 'Done') }}件</td></tr>
                                    <tr><th>医師</th><td :class="$style.alg_right">{{ backendData.experts[tab.value].online_dones[0] }}件</td></tr>
                                    <tr><th>心理士</th><td :class="$style.alg_right">{{ backendData.experts[tab.value].online_dones[1] }}件</td></tr>
                                    <tr><th>利用者数</th><td :class="$style.alg_right" colspan="2">{{ backendData.month.table.userCount[tab.value] }}人</td></tr>
                                    <tr><th>ココモニチェック</th><td :class="$style.alg_right" colspan="2">{{ calcWeightAve(backendData.month.counts[tab.value], backendData.month.weight[tab.value]) ?? '- ' }}点</td></tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">月</div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>年-月</th><th>平均点</th></tr>
                                    <tr v-for="data, index in backendData.month.graph[tab.value].labels" :key="data">
                                      <th>{{ data }}</th>
                                      <td :class="$style.alg_right">{{ backendData.month.graph[tab.value].datasets[0].data[index] }}点</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">曜日</div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>曜日</th><th>平均点</th></tr>
                                    <tr v-for="data in backendData.month.table.weekDays[tab.value]"
                                      :key="data"
                                      v-show="data.value > 0">
                                      <th>{{ data.label }}</th>
                                      <td :class="$style.alg_right">{{ data.value }}点</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">性別</div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr>
                                      <th>性別</th><th>平均点</th>
                                    </tr>
                                    <tr v-for="data in backendData.month.table.gender[tab.value]" :key="data">
                                      <th>{{ data.label }}</th>
                                      <td :class="$style.alg_right">{{ data.value ?? '- ' }}点</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                          <div :class="$style.card">
                            <contents-box
                              type="inner"
                              style="height: 100%;">
                              <div v-if="backendData" :class="$style.graph_contents">
                                <div :class="$style.graph_contents_title">時間</div>
                                <div :class="$style.graph_contents_table">
                                  <table>
                                    <tr><th>相談時間帯</th><th>平均点</th></tr>
                                    <tr v-for="data, index in backendData.scheduleTime[tab.value].labelsForTable"
                                      :key="data">
                                      <th v-if="index < 3" :class="$style.alg_center">
                                        {{ data }}
                                      </th>
                                      <td v-if="index < 3" :class="$style.alg_right">
                                        {{ backendData.month.table.receptionTime?.[tab.value]?.[index] ?? '- ' }}点
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </contents-box>
                          </div>
                        </div>
                        <spacer :y="2" />
                        <div :class="$style.wide_contents">
                          <contents-box
                            type="inner">
                            <div v-if="backendData" :class="$style.graph_contents">
                              <div :class="$style.graph_contents_title">相談内容</div>
                              <spacer :y="2" />
                              <div :class="$style.wide_contents_block">
                                <div :class="$style.graph_contents_figure_full">
                                  <div :class="$style.graph_size_max">
                                    <bar-graph
                                      Axis="y"
                                      :labelsData="backendData.worries[tab.value].labels"
                                      :datasetsData="backendData.worries[tab.value].datasets"
                                      :showDataLabels="true"
                                      :colorMode="tab.value" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </contents-box>
                        </div>
                        <spacer :y="2" />
                        <div :class="$style.wide_contents">
                          <contents-box
                            type="inner">
                            <div v-if="backendData" :class="$style.graph_contents">
                              <div :class="$style.graph_contents_title">オンライントスアップ</div>
                              <div :class="$style.graph_contents_block">
                                <div v-if="backendData.tossup[tab.value].users.length" :class="[$style.graph_contents_table, $style.graph_contents_table_wide]">
                                  <table>
                                    <tr><th>人数</th><td :class="$style.alg_right"><span :class="$style.large_number">{{ backendData.tossup[tab.value].transferOnline }}</span>人</td></tr>
                                    <tr>
                                      <th>ID</th>
                                      <th>過去テキスト件数</th>
                                    </tr>
                                    <tr
                                      v-for="(data, index) in backendData.tossup[tab.value].users"
                                      :key="data.customer_id"
                                      v-show="index < 10 || tossupExpanded">
                                      <td :class="[$style.alg_left, $style.col_id]">
                                        <span :class="$style.row_number">{{ index + 1 }}.</span>
                                        <router-link
                                          :to="`${historyBasePath}/${data.user_id}`"
                                          target="_blank">{{ data.customer_id }}</router-link>
                                      </td>
                                      <td :class="$style.alg_right">{{ data.text_count }} 件</td>
                                    </tr>
                                    <tr v-if="backendData.tossup[tab.value].users.length > 10">
                                      <td colspan="2" :class="$style.alg_center">
                                        <a v-if="!tossupExpanded" href="#" @click.prevent="tossupExpanded = true" :class="$style.expand_link">
                                          さらに{{ backendData.tossup[tab.value].users.length - 10 }}件を表示
                                        </a>
                                        <a v-else href="#" @click.prevent="tossupExpanded = false" :class="$style.expand_link">
                                          折りたたむ
                                        </a>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                                <div v-else>選択の期間内にトスアップはありませんでした</div>
                              </div>
                            </div>
                          </contents-box>
                        </div>
                        <spacer :y="2" />
                        <div :class="$style.wide_contents">
                          <contents-box
                            type="inner">
                            <div v-if="backendData" :class="$style.graph_contents">
                              <div :class="$style.graph_contents_title">当日キャンセル</div>
                              <div :class="$style.graph_contents_block">
                                <div v-if="cancellationSorted(tab.value).length" :class="[$style.graph_contents_table, $style.graph_contents_table_wide]">
                                  <table>
                                    <tr><th colspan="3">件数</th><td :class="$style.alg_right"><span :class="$style.large_number">{{ cancellationSorted(tab.value).length }}</span>件</td></tr>
                                    <tr>
                                      <th>予約日</th>
                                      <th>ID</th>
                                      <th>キャンセル理由</th>
                                      <th>処理者</th>
                                    </tr>
                                    <tr
                                      v-for="(data, index) in cancellationSorted(tab.value)"
                                      :key="index"
                                      v-show="index < 10 || cancelExpanded">
                                      <td :class="[$style.alg_center, $style.col_date]">{{ formatDate(data.schedule_date) }}</td>
                                      <td :class="[$style.alg_left, $style.col_id]">
                                        <span :class="$style.row_number">{{ index + 1 }}.</span>
                                        <router-link
                                          :to="`${historyBasePath}/${data.user_id}`"
                                          target="_blank">{{ data.customer_id }}</router-link>
                                      </td>
                                      <td>{{ helper.master.labels.reserve.cancel_reason[data.cancel_reason] }}</td>
                                      <td :class="$style.alg_center">{{ getCancelUserTypeLabel(data) }}</td>
                                    </tr>
                                    <tr v-if="cancellationSorted(tab.value).length > 10">
                                      <td colspan="4" :class="$style.alg_center">
                                        <a v-if="!cancelExpanded" href="#" @click.prevent="cancelExpanded = true" :class="$style.expand_link">
                                          さらに{{ cancellationSorted(tab.value).length - 10 }}件を表示
                                        </a>
                                        <a v-else href="#" @click.prevent="cancelExpanded = false" :class="$style.expand_link">
                                          折りたたむ
                                        </a>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                                <div v-else>選択の期間内に当日キャンセルはありませんでした</div>
                              </div>
                            </div>
                          </contents-box>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="['online', 'onlineOnly', 'virtualOnly'].includes(tab.value)">
                      <p>選択の期間内に該当するデータがありません</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </contents-box>
          <!-- <spacer :y="2" />
          <contents-box>
            <div :class="$style.wide_contents">
              <div v-if="symptoms">
                <div v-for="tab in analytics_tabs" :key="tab">
                  <div v-if="tab.check">
                    <contents-box
                      type="inner">
                      <div v-if="symptoms.length" :class="$style.graph_contents_symptoms">
                        <div :class="$style.graph_contents_title">暫定診断</div>
                        <div :class="$style.graph_contents_symptomsTable">
                          <table>
                            <thead>
                              <tr>
                                <th>大分類</th>
                                <th :class="$style.symptoms_number">人数</th>
                                <th>中分類（内訳）</th>
                                <th :class="$style.symptoms_number">人数</th>
                              </tr>
                            </thead>
                            <tbody>
                              <template v-for="data in symptoms">
                                <tr v-for="(detail, index) in data.detail" :key="detail.label">
                                  <template v-if="index === 0">
                                    <td :rowspan="data.detail.length" :class="$style.alg_left_plus_space">{{ data.label }}</td>
                                    <td :rowspan="data.detail.length" :class="$style.alg_right">{{ data.count }}人</td>
                                  </template>
                                  <td :class="$style.alg_left_plus_space">{{ detail.label }}</td>
                                  <td :class="$style.alg_right">{{ detail.count }}人</td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div v-else>暫定診断のデータはありません</div>
                    </contents-box>
                  </div>
                </div>
              </div>
            </div>
          </contents-box> -->
        </loader-simple>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ContentsBox from '@/views/components/ContentsBox.vue';
import BasicBtn from '@/views/components/BasicBtn.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import Spacer from '@/views/components/Spacer.vue';
import DateSmallPicker from '@/views/components/DateSmallPicker.vue';
import DonutGraph from '@/views/components/DonutGraph.vue';
import PieGraph from '@/views/components/PieGraph.vue';
import BarGraph from '@/views/components/BarGraph.vue';
import MixGraph from '@/views/components/MixGraph.vue';
import AnalyticsCommon from '@/views/components/AnalyticsCommon.vue';
import GuideIcon from '@/views/components/GuideIcon.vue';
import moment from 'moment';
import cf from '@/mixins/commonFunctions.js';
import { CHART_COLORS } from '@/constants/color.js';

export default {
  name: 'analyticsSelect',
  mixins: [cf],
  props: {
    mode: {
      type: String,
      default: 'operator',
      validator: (v) => ['operator', 'teacher'].includes(v),
    },
    school: {
      type: Object,
      default: null,
    },
  },
  components: {
    ContentsBox,
    BasicBtn,
    LoaderSimple,
    Spacer,
    DateSmallPicker,
    DonutGraph,
    PieGraph,
    BarGraph,
    MixGraph,
    AnalyticsCommon,
    GuideIcon,
  },
  data() {
    return {
      flag: {
        loader: true,
        doneTextAnalytics: false,
        doneReserveAnalytics: false,
      },
      startDate: moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD'),
      // startDate: moment('2023-02-1').format('YYYY-MM-DD'), // 検証用
      endDate: moment(new Date()).format('YYYY-MM-DD'),
      // endDate: moment('2023-02-28').format('YYYY-MM-DD'), // 検証用
      organization_types: [], // 0: 学校, 1: 企業
      account_types: [],
      school_types: [],
      targetSchool: 0,
      targetArea: 0,
      backendData: null,
      // 性別テーブル行の labels[i] と対応する unique キー名
      genderUniqueKeys: ['male', 'female', 'other'],
      usedTextAve: null,
      usedOnlineOnlyAve: null,
      usedVirtualOnlyAve: null,
      countAnalytics: null,
      symptoms: null,
      schools: [],
      // addQuery: [],
      accountsData: [],
      tossupExpanded: false,
      cancelExpanded: false,
      analyticsLoading: false,
      analytics_tabs: [
        {
          label: 'テキスト',
          value: 'text',
          check: true,
        },
        {
          label: 'オンライン',
          value: 'onlineOnly',
          check: false,
        },
        {
          label: 'バーチャル',
          value: 'virtualOnly',
          check: false,
        },
      ],
      tabBackgroundColor: CHART_COLORS.counselingType.text,
      tabColorText: CHART_COLORS.counselingType.text,
      tabColorOnlineVirtual: CHART_COLORS.counselingType.onlineVirtual,
      tabColorOnline: CHART_COLORS.counselingType.online,
      tabColorVirtual: CHART_COLORS.counselingType.virtual,
      areas: [
        '北海道',
        '東北',
        '関東',
        '中部',
        '近畿',
        '中国',
        '四国',
        '九州沖縄',
      ],
      accountTypeItems: [
        {
          name: 'analyticsUser',
          label: '在学生',
          value: 1,
          checked: false,
        },
        {
          name: 'analyticsParent',
          label: '保護者',
          value: 2,
          checked: false,
        },
        {
          name: 'analyticsTeacher',
          label: '教職員',
          value: 3,
          checked: false,
        },
      ],
      organizationTypeItems: [
        {
          name: 'analyticsIsSchool',
          label: '学校',
          value: 0,
          checked: false,
        },
        {
          name: 'analyticsIsCompany',
          label: '企業',
          value: 1,
          checked: false,
        },
      ],
      schoolTypeItems: [
        {
          name: 'analyticsElementary',
          label: '小学校',
          value: 1,
          checked: false,
        },
        {
          name: 'analyticsJuniorHigh',
          label: '中学校',
          value: 2,
          checked: false,
        },
        {
          name: 'analyticsHigh',
          label: '高校',
          value: 3,
          checked: false,
        },
        {
          name: 'analyticsUniv',
          label: '専門・短大・大学',
          value: 4,
          checked: false,
        },
        {
          name: 'analyticsFree',
          label: 'フリースクール',
          value: 5,
          checked: false,
        },
        {
          name: 'personal',
          label: '個人向け',
          value: 0,
          checked: false,
        },
      ],
      exclusionCancel: false,
      analyzedTextData: [],
      analyzedReserveData: [],
      targetCommonData: null,
      targetTextData: null,
      targetReserveData: null,
      onayami: {
        text: [],
        online: [],
      },
    };
  },
  watch: {
    startDate: {
      handler() {
        if (!this.startDate) {
          const { startDate, ...queryWithoutStartDate } = this.$route.query;
          this.$router.replace({ query: queryWithoutStartDate }, () => {});
        }
      },
      deep: true,
    },
    endDate: {
      handler() {
        if (!this.endDate) {
          const { endDate, ...queryWithoutEndDate } = this.$route.query;
          this.$router.replace({ query: queryWithoutEndDate }, () => {});
        }
      },
      deep: true,
    },
    organization_types: {
      handler(newVal) {
        // 配列に新しい要素が追加された場合、クエリパラメータを更新する
        if (this.organization_types && newVal) {
          const organizationTypes = this.organization_types.join(',');
          const addQuery = { ...this.$route.query, organizationTypes };
          this.$router.push({ query: addQuery }, () => {});
        }
        // 絞り込みのデータがない時パラメータを削除する
        if (!this.organization_types.length && !newVal.length) {
          const { organizationTypes, ...queryWithoutOrganizationTypes } = this.$route.query;
          this.$router.replace({ query: queryWithoutOrganizationTypes }, () => {});
        }
      },
      deep: true,
    },
    account_types: {
      handler(newVal) {
        // 配列に新しい要素が追加された場合、クエリパラメータを更新する
        if (this.account_types && newVal) {
          const accountTypes = this.account_types.join(',');
          const addQuery = { ...this.$route.query, accountTypes };
          this.$router.push({ query: addQuery }, () => {});
        }
        // 絞り込みのデータがない時パラメータを削除する
        if (!this.account_types.length && !newVal.length) {
          const { accountTypes, ...queryWithoutAccountTypes } = this.$route.query;
          this.$router.replace({ query: queryWithoutAccountTypes }, () => {});
        }
      },
      deep: true,
    },
    school_types: {
      handler(newVal) {
        // 配列に新しい要素が追加された場合、クエリパラメータを更新する
        if (this.school_types && newVal) {
          const schoolTypes = this.school_types.join(',');
          const addQuery = { ...this.$route.query, schoolTypes };
          this.$router.push({ query: addQuery }, () => {});
        }
        // 絞り込みのデータがない時パラメータを削除する
        if (!this.school_types.length && !newVal.length) {
          const { schoolTypes, ...queryWithoutSchoolTypes } = this.$route.query;
          this.$router.replace({ query: queryWithoutSchoolTypes }, () => {});
        }
      },
      deep: true,
    },
    targetArea: {
      handler(newVal) {
        if (newVal !== 0) {
          const targetArea = newVal;
          const query = { ...this.$route.query };
          if (query.targetArea !== targetArea) {
            query.targetArea = targetArea;
            this.$router.push({ query });
          }
        } else {
          const query = { ...this.$route.query };
          if (query.targetArea) {
            delete query.targetArea;
            this.$router.push({ query });
          }
        }
      },
      immediate: true,
    },
    targetSchool: {
      handler(newVal) {
        if (newVal !== null) {
          const targetSchool = newVal;
          const query = { ...this.$route.query };
          if (query.targetSchool !== targetSchool) {
            query.targetSchool = targetSchool;
            this.$router.push({ query });
          }
        } else {
          const query = { ...this.$route.query };
          if (query.targetSchool) {
            delete query.targetSchool;
            this.$router.push({ query });
          }
        }
      },
      immediate: true,
    },
  },
  async created() {
    if (window.performance) {
      /**
       * ページのロードのタイプによって処理を分ける
       * 意図的にリロードされたときは絞り込み条件を全てクリアして
       * デフォルトの期間のみが設定された状態のデータを表示する
       * console.log(window.performance.navigation.type);
       * 0 : ブラウザで検索orリンクのクリック
       * 1 : リロード
       * 2 : 履歴から
       */
      if (window.performance.navigation.type === 1) {
        await this.reloadClearFilter();
      }
    }

    // teacher モードの場合は自校を強制設定
    if (this.isTeacherMode && this.school) {
      this.targetSchool = this.school.id;
      this.organization_types = this.school.is_company ? [1] : [0];
    }

    this.updateType();
    this.receiveDate();
    if (!this.isTeacherMode) {
      this.updateArea();
      this.updateSchool();
    }
    this.getAccounts();
    if (!this.isTeacherMode) {
      this.getSchools();
    } else {
      this.flag.loader = false;
    }

    this.setAccountTypeItemsLabel();
  },
  computed: {
    ...mapState(['helper', 'user']),
    isTeacherMode() {
      return this.mode === 'teacher';
    },
    historyBasePath() {
      return this.isTeacherMode ? '/teacher/history' : '/operator/history';
    },
    analyticsApiPrefix() {
      return this.isTeacherMode ? '/v1/teacher/analytics' : '/v1/analytics';
    },
    tabQueryName() {
      return this.isTeacherMode ? 'analytics' : 'analyticsselect';
    },
    // teacher モードでJWT認証ヘッダーを取得
    teacherAuthHeaders() {
      if (!this.isTeacherMode) return {};
      const ls = cf.getLocalStorage('wtt');
      if (ls && ls.jwt) {
        return { Authorization: `${ls.jwt.type} ${ls.jwt.token}` };
      }
      return {};
    },
    targetAccountType() {
      let array = [];
      let all = true;
      this.accountTypeItems.forEach((row) => {
        if (row.checked) {
          all = false;
          array.push(row.value);
        }
      });
      if (all) array = [1, 2, 3];
      return array;
    },
    targetSchoolType() {
      let array = [];
      let all = true;
      this.schoolTypeItems.forEach((row) => {
        if (row.checked) {
          all = false;
          array.push(row.value);
        }
      });
      // 学校タイプ未選択（全選択扱い）時は企業(6)も含めて取得する。
      // 企業はチェックボックスUIには出さないが、企業ソートのセレクトに表示するため取得対象に含める
      if (all) array = [0, 1, 2, 3, 4, 5, 6];
      return array;
    },
    allFilter() {
      const result = {
        start: this.startDate,
        end: this.endDate,
        account_types: this.account_types,
        school_types: this.school_types,
        targetSchool: this.targetSchool,
        targetArea: this.targetArea,
        targetOrganizationType: this.targetOrganizationType,
      };
      return result;
    },
    isOrganizationTypeSchoolValid() {
      return this.organization_types.includes(0) || this.organization_types.length === 0;
    },
    isOrganizationTypeCompanyValid() {
      return this.organization_types.includes(1) || this.organization_types.length === 0;
    },
    filteredSchools() {
      return this.schools.filter((school) => {
        if (this.isOrganizationTypeSchoolValid && this.isOrganizationTypeCompanyValid) {
          return true; // すべての組織タイプが選択されている場合、学校も企業も表示
        }
        const isCompany = this.organization_types.includes(1);
        return isCompany === !!school.is_company;
      });
    },
    filteredAccountTypeItems() {
      const availableAccountTypes = this.isOrganizationTypeSchoolValid ? [1, 2, 3] : [1, 3]; // 学校が有効の場合は、在学生、保護者、教職員を表示 / 学校が無効の場合は企業に所属可能なaccountTypeのみ表示
      return this.accountTypeItems.filter((item) => availableAccountTypes.includes(item.value));
    },
    schoolSortLabel() {
      if (this.isOrganizationTypeSchoolValid && this.isOrganizationTypeCompanyValid) {
        return '学校・企業ソート';
      }
      if (this.isOrganizationTypeSchoolValid) {
        return '学校ソート';
      }
      if (this.isOrganizationTypeCompanyValid) {
        return '企業ソート';
      }
      return null;
    },
    targetOrganizationType() {
      // organization_typesでは画面上の選択値をすべて保持しているが、実際にAPIに絞り込み条件として渡す値は学校/企業のどちらか一つ
      if (this.organization_types.length === 1) {
        return this.organization_types[0] === 0 ? 'school' : 'company';
      }
      return null;
    },
  },
  methods: {
    // 配列の合計を計算
    calcSum(arr) {
      let result = 0;
      arr.forEach((data) => {
        result += data;
      });
      return result;
    },

    // 配列の平均値を計算、第二引数は小数点以下何桁まで出すかを指定
    calcAve(arr, digit = 1) {
      if (!arr || arr.length === 0) return undefined;
      if (arr.length === 1) return arr[0];
      const rowAve = arr.reduce((a, b) => a + b) / arr.length;
      return Math.round(rowAve * 10 ** digit) / 10 ** digit;
    },

    // 加重平均を返す
    calcWeightAve(arr1, arr2) {
      if (!arr1?.length || !arr2?.length) return 0;
      const divisor = arr1.reduce((sum, elem) => sum + elem, 0);
      if (divisor === 0) return null;
      const result = Math.round((arr2.reduce((sum, elem) => sum + elem, 0) / divisor) * 10) / 10;
      return result;
    },

    calcObjectSum(obj) {
      let result = 0;
      Object.keys(obj).forEach((data) => {
        result += obj[data];
      });
      return result;
    },

    // ページがリロードで描画された際に検索条件を全てクリア
    reloadClearFilter() {
      const conditions = [
        'startDate',
        'endDate',
        'accountTypes',
        'schoolTypes',
        'targetSchool',
        'targetArea',
        'organization_types',
        'targetType',
        'targetCount',
        'targetRange',
        'sortedOrder',
        'displayRange',
      ];

      const result = this.$route.query;
      conditions.forEach((condition) => {
        delete result[condition];
      });
      this.$router.push({ tab: this.tabQueryName });
    },

    // ユーザ数の取得
    getAccounts(data) {
      if (this.isTeacherMode) return;
      if (!data) {
        this.accountsData = null;
        return true;
      }
      const params = {
        graphRange: data.graphRange,
        sortedCriteria: data.sortedCriteria,
        includeInactive: data.includeInactive,
        targetOrganizationType: this.targetOrganizationType,
      };
      this.axios({
        method: 'GET',
        url: `${this.analyticsApiPrefix}/get/accounts`,
        params,
        headers: this.teacherAuthHeaders,
      })
        .then((response) => {
          this.accountsData = response.data;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },
    startAnalytics() {
      this.$refs.analyticsCommon.sendTrend();
    },
    /** アナリティクスデータの取得 */
    getAnalytics(data) {
      this.analyticsLoading = true;

      const params = {
        start: this.startDate,
        end: this.endDate,
        account_types: this.account_types,
        school_types: this.targetOrganizationType === 'company' ? null : this.school_types, // 企業の場合は学校タイプは不要
        targetSchool: this.targetSchool,
        targetArea: this.targetArea,
        targetOrganizationType: this.targetOrganizationType,
        displayTrend: data.displayTrend,
        sortedTrend: data.sortedTrend,
        exclusionCancel: this.exclusionCancel,
      };
      this.axios({
        method: 'GET',
        url: `${this.analyticsApiPrefix}/get/data`,
        params,
        headers: this.teacherAuthHeaders,
      })
        .then((response) => {
          this.analyticsLoading = false;
          this.backendData = response.data;
          // 平均利用回数を小数第１位まで表示（ユーザー数0の場合はnull: ゼロ除算でInfinity防止）
          const textCount = this.backendData.month.table.userCount.text;
          const onlineOnlyCount = this.backendData.month.table.userCount.onlineOnly;
          const virtualOnlyCount = this.backendData.month.table.userCount.virtualOnly;
          this.usedTextAve = textCount > 0 ? (this.ctValue('texts') / textCount).toFixed(1) : null;
          this.usedOnlineOnlyAve = onlineOnlyCount > 0 ? (this.ctValue('onlineOnly') / onlineOnlyCount).toFixed(1) : null;
          this.usedVirtualOnlyAve = virtualOnlyCount > 0 ? (this.ctValue('virtualOnly') / virtualOnlyCount).toFixed(1) : null;
          // バックエンドからは全ての暫定診断をとってきているが、値が０のラベルを除いて配列を再形成
          const symptomsData = response.data.diagnoses;
          const filteredData = symptomsData
            .map((item) => ({
              ...item,
              detail: item.detail.filter((detail) => detail.count >= 1).sort((a, b) => b.count - a.count),
            }))
            .filter((item) => item.detail.length > 0)
            .sort((a, b) => b.count - a.count);
          this.symptoms = filteredData;
        })
        .catch((error) => {
          this.analyticsLoading = false;
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
      // 最終的には不要になる
    },
    getSchools() {
      this.axios({
        method: 'GET',
        url: '/v1/school/get/list',
        params: {
          schoolTypes: this.targetSchoolType,
          isUsers: false,
        },
      })
        .then((response) => {
          const res = response.data.data;
          res.data = res.data.filter((data) => data.id !== 13 && data.id !== 15);
          this.schools = res.data;
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        })
        .finally(() => {
          this.flag.loader = false;
        });
    },

    // タブ値に対応する相談タイプの色を取得
    getTabColor(value) {
      if (value === 'text') return CHART_COLORS.counselingType.text;
      if (value === 'online') return CHART_COLORS.counselingType.onlineVirtual;
      if (value === 'onlineOnly') return CHART_COLORS.counselingType.online;
      if (value === 'virtualOnly') return CHART_COLORS.counselingType.virtual;
      return CHART_COLORS.counselingType.text;
    },

    // counselingType.table から name で値を取得
    ctValue(name) {
      if (!this.backendData) return 0;
      const item = this.backendData.counselingType.table.find((t) => t.name === name);
      return item ? item.value : 0;
    },

    // タブ値に対応する平均利用回数を取得
    getAveValue(value) {
      if (value === 'text') return this.usedTextAve;
      if (value === 'onlineOnly') return this.usedOnlineOnlyAve;
      if (value === 'virtualOnly') return this.usedVirtualOnlyAve;
      return null;
    },

    // 平均利用回数が有効な数値かどうか（NaN/Infinity/null でない）
    isValidAve(ave) {
      return ave !== null && Number.isFinite(Number(ave));
    },

    // 「総利用状況」グラフから、現在選択されていないタブ名のデータセットを除外する
    filterMonthGraphDatasets(datasets) {
      if (!datasets) return [];
      const tabLabels = this.analytics_tabs.map((t) => t.label);
      const activeTab = this.analytics_tabs.find((t) => t.check);
      const activeLabel = activeTab ? activeTab.label : null;
      const hideLabels = tabLabels.filter((l) => l !== activeLabel);
      return datasets.filter((ds) => !hideLabels.includes(ds.label));
    },

    // グラフタブ切り替え
    toggleTab(args) {
      this.tabBackgroundColor = this.getTabColor(args);

      this.analytics_tabs.forEach((tab) => {
        if (tab.value === args) {
          if (tab.check === false) {
            tab.check = !tab.check;
          }
        } else {
          tab.check = false;
        }
      });
    },

    updateSchool(e) {
      if (e) {
        this.targetSchool = Number(e.target.value);
        if (!Number(e.target.value)) this.targetSchool = null;
      }
      const query = this.$route.query;
      // アナリティクスを開いている時のみパラメータ付与
      if (query.tab === this.tabQueryName && !e) {
        if (query.targetSchool) {
          this.targetSchool = Number(query.targetSchool);
        }
      }
    },

    /** タイプによる絞り込み(アカウント・学校) */
    updateType(e, name) {
      const allQuery = this.$route.query;

      // 組織タイプ変更時の処理
      if (name === 'organization') {
        // チェック状態によって影響を受ける項目の選択状態をクリアする

        // 利用者タイプ
        delete allQuery.accountTypes;
        this.accountTypeItems.forEach((row) => {
          row.checked = false;
        });
        this.account_types = [];
        // 組織タイプの変更に応じて、利用者タイプのチェックボックスラベルを更新する
        this.setAccountTypeItemsLabel();

        // 学校タイプ
        delete allQuery.schoolTypes;
        this.schoolTypeItems.forEach((row) => {
          row.checked = false;
        });
        this.school_types = [];

        // 学校・企業ソート
        delete allQuery.targetSchool;
        this.targetSchool = 0;
        this.getSchools(); // 学校・企業ソート選択肢の更新
      }

      if (allQuery.organizationTypes && !name) {
        const organizationQuery = allQuery.organizationTypes.split(',');
        const queryNumber = organizationQuery.map((str) => parseInt(str, 10));
        if (queryNumber && !name) {
          for (let i = 0; i < queryNumber.length; i += 1) {
            this.organizationTypeItems.forEach((row) => {
              if (queryNumber[i] === row.value) {
                row.checked = true;
                this.organization_types.push(row.value);
              }
            });
          }
        }
      }
      if (allQuery.accountTypes && !name) {
        const accountQuery = allQuery.accountTypes.split(',');
        const queryNumber = accountQuery.map((str) => parseInt(str, 10));
        if (queryNumber && !name) {
          for (let i = 0; i < queryNumber.length; i += 1) {
            this.accountTypeItems.forEach((row) => {
              if (queryNumber[i] === row.value) {
                row.checked = true;
                this.account_types.push(row.value);
              }
            });
          }
        }
      }
      if (allQuery.schoolTypes && !name) {
        const schoolQuery = allQuery.schoolTypes.split(',');
        const queryNumber = schoolQuery.map((str) => parseInt(str, 10));
        if (queryNumber && !name) {
          for (let i = 0; i < queryNumber.length; i += 1) {
            this.schoolTypeItems.forEach((row) => {
              if (queryNumber[i] === row.value) {
                row.checked = true;
                this.school_types.push(row.value);
              }
            });
          }
        }
      }
      if (name) {
        this[`${name}TypeItems`].forEach((row) => {
          if (e.target.id === row.name) row.checked = e.target.checked;
        });

        if (name === 'school') {
          this.targetSchool = 0;
          this.getSchools();
        }

        // this.organization_types/this.account_types/this.school_types更新
        const targetArray = this[`${name}_types`];
        const tgt = e.target;
        const value = Number(tgt.value);
        if (tgt.checked) { // 追加
          targetArray.push(value);
        } else { // 削除
          const index = targetArray.indexOf(value);
          targetArray.splice(index, 1);
        }
      }
    },
    /** 期間の始点と終点取得 */
    receiveDate(args) {
      const query = this.$route.query;
      // アナリティクスを開いている時のみパラメータ付与
      if (query.tab === this.tabQueryName) {
        // 期間の初期値の始点と終点を付与
        if (!query.startDate && !query.endDate && !args) {
          const addQuery = { ...this.$route.query, startDate: this.startDate, endDate: this.endDate };
          this.$router.push({ query: addQuery }, () => {});
          // this.$router.push('/operator/');
        }
        // 始点のクエリデータを絞り込みに反映
        if (query.startDate && !args) {
          this.startDate = query.startDate;
        }
        // 終点ののクエリデータを絞り込みに反映
        if (query.endDate && !args) {
          this.endDate = query.endDate;
        }
        if (args) {
          if (args.date === 'Invalid date') {
            this[args.name] = null;
          } else {
            this[args.name] = args.date;
            const addQuery = { ...this.$route.query, [args.name]: args.date };
            this.$router.push({ query: addQuery }, () => {});
          }
        }
      }
    },
    updateArea() {
      const query = this.$route.query;
      // アナリティクスを開いている時のみパラメータ付与
      if (query.tab === this.tabQueryName) {
        if (query.targetArea) {
          this.targetArea = query.targetArea;
          const targetArea = this.targetArea;
          const addQuery = { ...this.$route.query, targetArea };
          this.$router.push({ query: addQuery }, () => {});
        }
      }
    },

    searchSchool() {
      const array = [];
      this.schools.forEach((row) => {
        if (this.targetSchoolType.includes(row.school_type)) {
          array.push(row);
        }
      });
      this.schools = array;
    },

    setAccountTypeItemsLabel() {
      this.$nextTick(() => {
        this.accountTypeItems.forEach((item) => {
          const labels = [];
          if (this.isOrganizationTypeSchoolValid) {
            labels.push(this.helper.master.labels.users.account_type[`${item.value}`]);
          }
          if (this.isOrganizationTypeCompanyValid) {
            const companyLabel = this.helper.master.labels.users.company_account_type[`${item.value}`];
            if (companyLabel) { // 企業アカウントタイプのラベルが存在する場合のみ追加
              labels.push(companyLabel);
            }
          }
          if (labels.length === 0) {
            labels.push(this.helper.master.labels.users.account_type[`${item.value}`]); // デフォルトラベル
          }
          item.label = labels.join('・');
        });
      });
    },

    getCancelUserTypeLabel(cancellationOnTheDayData) {
      if (cancellationOnTheDayData.cancel_user_id === cancellationOnTheDayData.user_id) {
        // 利用者
        return (cancellationOnTheDayData.is_company
          ? this.helper.master.labels.users.company_account_type[cancellationOnTheDayData.account_type]
          : this.helper.master.labels.users.account_type[cancellationOnTheDayData.account_type]) || '利用者';
      }
      if (cancellationOnTheDayData.cancel_user_id === cancellationOnTheDayData.counselor_id) {
        // 専門家
        return this.helper.master.labels.users.account_type[cancellationOnTheDayData.counselor_account_type] || '専門家';
      }
      return '事務局';
    },
    cancellationSorted(tabValue) {
      if (!this.backendData || !this.backendData.cancellationOnTheDay[tabValue]) return [];
      return [...this.backendData.cancellationOnTheDay[tabValue]].sort((a, b) => {
        const dateA = a.schedule_date || '';
        const dateB = b.schedule_date || '';
        return dateB.localeCompare(dateA);
      });
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      return moment(dateStr).format('YYYY年MM月DD日');
    },
  },
};
</script>

<style lang="scss" module>
.spacious {
  position: relative;
  left: 50%;
  transform: translate(-50%, 0);
  @media screen and (max-width: 1080px) {
    max-width: 100%;
    width: 100%;
  }
}
.outer_flex {
  display: block;
  &_left {
    flex-grow: .5;
    height: 100%;
    max-width: 100%;
    position: relative;
    z-index: 10;
    top: 0;
    width: 100%;
  }
  &_right {
    flex-grow: 9.5;
    width: 100%;
  }
}
.filter {
  dl {
    display: flex;
    align-items: center;
    margin: 0;
  }
  dt {
    width: 7em;
    white-space: nowrap;
    i {
      margin-right: .5em;
    }
  }
  dd {
    display: flex;
    align-items: center;
    margin-left: 1em;
  }

  .datePicker {
    width: 150px;
    display: flex;
    align-items: center;
    > div {
      width: 100%;
    }
  }

  .tilde {
    margin: 0 1em;
    font-size: 1.4em;
  }

  &_label {
    font-weight: bold;
    margin-bottom: 0.5em;
    i {
      margin-right: .5em;
    }
  }

  &_row {
    display: flex;
    column-gap: 3em;
    row-gap: 1em;
    flex-wrap: wrap;
    @include md-view {
      display: block;
    }
  }

  &_item {
    flex: 1;
    dl {
      display: flex;
      align-items: center;
      margin: 0;
    }
    dt {
      width: auto;
      white-space: nowrap;
      margin-right: 1em;
      i {
        margin-right: .5em;
      }
    }
    dd {
      flex: 1;
      margin-left: 0;
    }
    @include md-view {
      &:not(:first-child) {
        margin-top: 1em;
      }
    }
  }

  &_item_auto {
    flex: 0 1 auto;

    // dl要素の場合（セレクトボックス用）
    dl {
      display: flex;
      align-items: center;
      margin: 0;
    }
    dt {
      width: auto;
      white-space: nowrap;
      margin-right: 1em;
      i {
        margin-right: .5em;
      }
    }
    dd {
      margin-left: 0;
      select {
        min-width: 200px;
      }
    }

    @include md-view {
      flex: 1 1 100%;
      &:not(:first-child) {
        margin-top: 1em;
      }
    }
  }

  @include sm-view {
    dl {
      display: block;
      margin: 1em 0 .4em;
    }
    dt {
      font-size: 14px;
      margin-bottom: 0.5em;
    }
    dd {
      margin: 0;
      width: 100%;
    }
    .datePicker {
      width: 100%;
      max-width: 150px;
    }
  }
}

.select {
  margin-left: -10px;
  display: flex;
  flex-wrap: wrap;
  > li {
    margin-left: 10px;
    &:not(:first-child) {
      margin-left: 1em;
    }
  }
  &_box {
    padding: 13px;
    background-color: var(--gray-sub);
    border: none;
    outline: none;
    border-radius: 8px;
    appearance: none;
  }
}
.search_tab {
  margin-left: 1em;
}
.tab_list {
  display: flex;
  li {
    &:not(:first-child) {
      margin-left: 8px;
    }
  }
  li:hover {
    transition: .3s all;
    color: white;
    background-color: var(--primary-color);
    &.tab_text {
      background-color: v-bind(tabColorText);
    }
    &.tab_online {
      background-color: v-bind(tabColorOnlineVirtual);
    }
    &.tab_onlineOnly {
      background-color: v-bind(tabColorOnline);
    }
    &.tab_virtualOnly {
      background-color: v-bind(tabColorVirtual);
    }
  }
}
.not_check {
  padding: 3px 10px;
  background-color: white;
  border-radius: 5px 5px 0 0;
  box-shadow: 0px 1px 4.45px 0.55px rgb(208 208 208 / 48%);
}
.check_tab {
  padding: 3px 10px;
  color: #333333;
  background-color: v-bind(tabBackgroundColor);
  border-radius: 5px 5px 0 0;
}
.cursor_poiter {
  cursor: pointer;
}
.who5_analytics {
  text-align: center;
  &_pie {
    &_common {
      margin: 0 auto;
      background-color: rgb(129, 213, 82);
      width: 200px;
      height: 200px;
      border-radius: 50%;
    }
    &_text {
      margin: 0 auto;
      background-color: rgb(116, 176, 191);
      width: 200px;
      height: 200px;
      border-radius: 50%;
    }
    &_online {
      margin: 0 auto;
      background-color: rgb(221, 165, 66);
      width: 200px;
      height: 200px;
      border-radius: 50%;
    }
  }
}
.average {
  &_label {
    background: white;
    display: inline-block;
    margin-top: 50px;
    font-weight: bold;
    padding: 0 5px;
  }
  &_score {
    color: white;
    font-size: 2em;
    font-weight: bold;
  }
}
.card {
  margin-top: 10px;
  width: 32.5%;
  &_container {
    margin-top: -10px;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-wrap: wrap;
    @media screen and (max-width:927px) {
      margin-left: -13px;
    }
    @media screen and (max-width:764px) {
      margin-left: 0;
    }
  }
  @media screen and (max-width:927px) {
    margin-left: 13px;
    width: 47%;
  }
  @media screen and (max-width:764px) {
    width: 100%;
    margin-left: 0;
  }
}
.card_container:after {
  content: '　';
  width: 31%;
  margin: 8px;
}
.graph_contents {
  &_title {
    padding: 3px;
    font-size: 1.1em;
    font-weight: 500;
    small {
      display: flex;
      font-size: 12px;
      align-items: center;
      span {
        display: block;
        height: 1em;
      }
    }
  }
  &_figure {
    &_equality {
      flex-grow: 1;
    }
    &_full {
      width: 100%;
      flex-grow: 1;
    }
  }
  &_table {
    max-width: 400px;
    flex-grow: 1;
    display: flex;
    margin: 15px auto;
    font-size: .8em;
    &_wide {
      max-width: 600px;
    }
    table {
      table-layout: fixed;
      width: 100%;
    }
    tr {
      background-color: #f8f8f8;;
      max-height: 20px;
    }
    tr:nth-child(odd) {
      background-color: var(--gray-sub);
    }
  }
  &_symptoms {
    width: 100%;
  }
  &_symptomsTable {
    max-width: 800px;
    flex-grow: 1;
    display: flex;
    margin: 15px auto;
    font-size: .8em;
    table {
      table-layout: fixed;
      width: 100%;
    }
    tr {
      background-color: #f8f8f8;;
      max-height: 20px;
    }
    tr:nth-child(odd) {
      background-color: var(--gray-sub);
    }
    .td {
      max-width: 10%;
    }
  }
}

.symptoms_number {
  width: 10%;
}

.alg {
  &_left {
    text-align: left;
    &_plus_space {
      padding-left: 1em;
    }
  }
  &_right {
    text-align: right;
    padding-right: .5em;
  }
  &_center {
    text-align: center;
  }
}
.graph_size {
  &_l, &_m, &_s {
    margin: 0 auto;
  }
  &_max {
    width: 100%;
  }
  &_l {
    width: 70%;
  }
  &_m {
    width: 50%;
  }
  &_s {
    width: 30%;
  }
}
.wide_contents {
  margin-bottom: 10px;
  &_block {
    display: flex;
    @include md-view {
      display: block;
    }
  }
}
.select_box_school {
  min-width: 20rem !important;
}
.usage_circle {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  border-radius: 50%;
  background: linear-gradient(135deg, #74b0bf 0%, #5a9db0 100%);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  &_inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif; // フォントスタイルを他のグラフと合わせる
  }
  &_value {
    font-size: 4em;
    font-weight: bold;
    line-height: 1;
    // 文字を白で縁取る（視認性向上のため）
    text-shadow:
      -1px -1px 0 #fff,
      1px -1px 0 #fff,
      -1px 1px 0 #fff,
      1px 1px 0 #fff;
  }
  &_unit {
    font-size: 1em;
    font-weight: 500;
    margin-top: 5px;
  }
}
.user_link {
  color: #007bff;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
.large_number {
  font-size: 1.5em;
  font-weight: bold;
}
.row_number {
  display: inline-block;
  width: 2.5em;
  text-align: right;
  color: gray;
  margin-right: 0.75em;
}
.col_date {
  width: 120px;
  white-space: nowrap;
}
.col_id {
  width: 130px;
  white-space: nowrap;
}
.expand_link {
  color: #007bff;
  text-decoration: none;
  font-size: 13px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.graph_contents_table:not(.graph_contents_table_wide) {
  table {
    th:first-child:nth-last-child(2),
    td:first-child:nth-last-child(2) {
      width: 65%;
    }
    th:first-child:nth-last-child(2) + th,
    td:first-child:nth-last-child(2) + td {
      width: 35%;
    }
  }
}
.note_text {
  font-size: 0.8em;
  color: #666;
  margin-top: 8px;
  margin-left: 1rem;
}
</style>
